import classNames from 'classnames';
import { useMemo } from 'react';
import { IntlShape, MessageDescriptor } from 'react-intl';

const TABLE_MESSAGES: Record<string, MessageDescriptor> = {
  searchInTable: {
    id: 'chatPage.SpeechBubble.toggle.table.searchInTable',
  },
  nothingFound: {
    id: 'chatPage.SpeechBubble.toggle.table.nothingFound',
  },
  noData: {
    id: 'chatPage.SpeechBubble.toggle.table.noData',
  },
  refineSearch: {
    id: 'chatPage.SpeechBubble.toggle.table.refineSearch',
  },
  loadMoreMessage: {
    id: 'chatPage.SpeechBubble.toggle.table.loadMoreMessage',
  },
  noMoreMessage: {
    id: 'chatPage.SpeechBubble.toggle.table.noMoreMessage',
  },
  saveVisualizationPreferences: {
    id: 'chatPage.SpeechBubble.toggle.table.savePreferencesTooltip',
  },
  saveVisualizationPreferencesSuccess: {
    id: 'chatPage.SpeechBubble.toggle.table.saveSuccess',
  },
  dialogTitle: {
    id: 'chatPage.SpeechBubble.toggle.table.dialog.title',
  },
  dialogCloseButtonText: {
    id: 'chatPage.SpeechBubble.toggle.table.dialog.closeButtonText',
  },
  dialogResetButtonText: {
    id: 'chatPage.SpeechBubble.toggle.table.dialog.resetButtonText',
  },
  dialogSearchPlaceholder: {
    id: 'chatPage.SpeechBubble.toggle.table.dialog.searchPlaceholder',
  },
  dialogNotFoundMessage: {
    id: 'chatPage.SpeechBubble.toggle.table.dialog.notFoundMessage',
  },
};

export const TABLE_CLASSES = classNames(
  'table',
  'table-layout-fixed',
  'table-column-overflow-hidden',
  'table-bordered',
  'table-sticky',
  'table-head-filled'
);

export const useTableIntl = (intl: IntlShape) => {

  /**
   * Memoized formatting.
   * Re-runs only if `intl` changes .
   */
  const messages = useMemo(() => {
    return {
      searchInTable: intl.formatMessage(TABLE_MESSAGES.searchInTable),
      nothingFound: intl.formatMessage(TABLE_MESSAGES.nothingFound),
      noData: intl.formatMessage(TABLE_MESSAGES.noData),
      refineSearch: intl.formatMessage(TABLE_MESSAGES.refineSearch),
      loadMoreMessage: intl.formatMessage(TABLE_MESSAGES.loadMoreMessage),
      noMoreMessage: intl.formatMessage(TABLE_MESSAGES.noMoreMessage),
      saveVisualizationPreferences: intl.formatMessage(
        TABLE_MESSAGES.saveVisualizationPreferences
      ),
      saveVisualizationPreferencesSuccess: intl.formatMessage(
        TABLE_MESSAGES.saveVisualizationPreferencesSuccess
      ),
      dialogTitle: intl.formatMessage(TABLE_MESSAGES.dialogTitle),
      dialogCloseButtonText: intl.formatMessage(
        TABLE_MESSAGES.dialogCloseButtonText
      ),
      dialogResetButtonText: intl.formatMessage(
        TABLE_MESSAGES.dialogResetButtonText
      ),
      dialogSearchPlaceholder: intl.formatMessage(
        TABLE_MESSAGES.dialogSearchPlaceholder
      ),
      dialogNotFoundMessage: intl.formatMessage(
        TABLE_MESSAGES.dialogNotFoundMessage
      ),
    };
  }, [intl]);

  return {
    ...messages,
    tableClasses: TABLE_CLASSES,
  };
};

